// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2h5RY","label":"styles_label__s6M1L"};